'use client'
import { ReactNode } from 'react'
import { TitleDefinition, TitleDefinitionList } from './TitleDefinition'
import { CellData, ColumnMapper } from './ColumnMapper'

export type TableRowData = CellData[] | Record<string, CellData>

export interface IVirtualTableProvider<T extends Object = any> {
	/**
	 * The raw list of items that are to be displayed in the ListView
	 * */
	items: T[]
	/**
	 * All the titles, representing all the columns of this object.
	 * If specified, the number of titles must match the number if array items or object properties returned from createColumns
	 * A variable number of title names can be passed to the actual ListView component to display a subset of the available columns
	 */
	getAllTitles?(): TitleDefinitionList
	/**
	 * This must return either an array of all the columns in the list view, or an object with properties specifying all the columns of the object.
	 * If allTitles  is specified, the number of array items or object properties must match the number of allTitles.
	 * This can either return text, or a ReactNode
	 */
	createRow(item: T, index: number): TableRowData
	getId?: (item: T) => string
	customCompare?: (titleDef: TitleDefinition, objA: T, objB: T, valA: ReactNode, valB: ReactNode) => number | undefined
}

export class VirtualTableProviderBase<T extends Object = any> implements IVirtualTableProvider<T> {
	items: T[]

	getId?: (item: T) => string
	constructor(items: T[]) {
		this.items = items
	}
	// registerFields(arr: any[]) {
	// 	this.fields = new ColumnMapper(arr)
	// }

	getAllTitles?(): TitleDefinitionList
	createRow(item: T, index: number): TableRowData {
		return []
	}
}
